import { EnvironmentInjector, inject } from '@angular/core';
import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { IonicModule, Platform } from '@ionic/angular';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { UrlService } from './services/url.service';
import { filter } from 'rxjs/operators';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';
import { ELEMENTOS_RED_DE_RIEGO } from './shared/enums/elementos-red-de-riego.enum';
import { SessionTabSyncService } from './services/session-tab-sync.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonicModule, MatSidenavModule, RouterModule],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly sessionTabSync = inject(SessionTabSyncService);
  private readonly platform = inject(Platform);
  private readonly router = inject(Router);
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly mps = inject(MatPaginatorIntl);
  private readonly urlService = inject(UrlService);
  readonly environmentInjector = inject(EnvironmentInjector);
  readonly ELEMENTOS_RED_RIEGO = ELEMENTOS_RED_DE_RIEGO;

  previousUrl: string = null;
  currentUrl: string = null;
  subscripcion: Subscription;

  constructor() {
    this.initializeApp();
    this.iconRegistry.addSvgIcon(
      'parcelas',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        '/assets/icon/cuaderno-campo/parcelas.svg'
      )
    );
  }

  ngOnInit() {
    console.log('version:', environment.version);

    this.sessionTabSync.start();

    this.subscripcion = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.urlService.setPreviousUrl(this.previousUrl);
      });

    const titulo = document.getElementsByClassName('title-page')[0];
    const titulo_env =
      environment.name !== 'PROD' ? '-' + environment.name : '';
    titulo.innerHTML = titulo.innerHTML + titulo_env;
  }

  ngAfterViewInit(): void {
    // Inicializa los labels por defecto para la paginacion de las Material Angular Table
    this.mps.itemsPerPageLabel = 'Paginación';
    this.mps.nextPageLabel = 'Siguente página';
    this.mps.previousPageLabel = 'Anterior página';
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      try {
        await StatusBar.setStyle({ style: Style.Default });
        await SplashScreen.hide();
      } catch (e) {
        console.log('No es un dispositivo movil');
      }
    });
  }

  ngOnDestroy(): void {
    this.sessionTabSync.stop();
    this.subscripcion.unsubscribe();
  }
}
